module.exports = __webpack_public_path__ + "static/contact-ae329cd4745437a97daf8f3fa87208be.png";